import ProfileCard from "../../profile/components/ProfileCard";

const DepartmentsList = (props: any) => {
  //only for these sub-departments we have separate department pages
  const subDepDepts = [
    "Design",
    "Customer Success",
    "Technology",
    "Operations",
  ];

  const DepartmentLogoMap: { [key: string]: string } = {
    Strategy: "strategy",
    "Supply Chain": "procurement",
    Hardware: "tech",
    "Data Science": "tech",
    Quality: "accounts",
    "Quality and Safety": "accounts",
    Sales: "sales",
    "Project Delivery": "operations",
    Marketing: "content",
    "New Initiatives": "strategy",
    Finance: "accounts",
    "Founder's Office": "management1",
    Procurement: "procurement",
    Design: "design",
    "Human Resources": "hr",
    Operations: "operations",
    HR: "hr",
    "Customer Success": "operations",
    Content: "content",
    "Electric R&D & Safety": "tech",
    Product: "tech",
    Management: "management1",
    Tech: "tech",
    Technology: "tech",
  };

  const getLogo = (department: string) => {
    return DepartmentLogoMap[department] || "nothing";
  };

  const getLink = (item: any) => {
    if (subDepDepts.includes(item.department)) {
      return `/hrm/departments/${item.department}`;
    }

    // direct employee list
    return `/hrm/employeeList/${encodeURIComponent(item.department)}/all`;
  };
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4  gap-x-2 gap-y-2 lg:gap-x-6 lg:gap-y-4 mt-3 pb-12 lg:pb-0">
      {props.empData &&
        props.empData
          .filter((d: any) => d.department !== null)
          .map((item: any, i: any) => {
            return (
              <div className="w-full lg:w-auto" key={i}>
                <ProfileCard
                  data={{
                    ...item,
                    logo: getLogo(item.department),
                    link: getLink(item),
                    count: item.count + " people",
                    department: item.department,
                  }}
                  key={i}
                />
              </div>
            );
          })}
    </div>
  );
};

export default DepartmentsList;
